import React from "react";
import Cinema from "../components/Cinema";

// NOTE: id=14 マッドマックス
export default () => <Cinema id={14} />;
